<div id="invoice-card">
  <dxo-card>
    <div class="header-container">
      <h2 class="card-body-header" data-e2e="payments-card-header">{{ PaymentCardHeader }}</h2>
    </div>
    <card-body *ngIf="billings$ | async as billings">
      <dxo-data-table
        [headers]="tableHeaders"
        [items]="billings"
        [showCardViewWhenMobile]="true"
        [dxoDataset]="[{ selector: 'dxo-table-cell > span', data: { pii: '', e2e: 'payments-table' } }]"
      >
        <ng-template dxoHeaderKey="invoice">
          <span
            tabindex="0"
            class="sort-header"
            (click)="onClickTableHeader(InvoiceKey)"
            (keypress)="onClickTableHeader(InvoiceKey)"
            data-e2e="invoice-period-title"
          >
            {{ InvoicePeriodAndNumberText }}
            <dxo-icon
              [class.ascending]="
                searchParameter.sortDirection === SortDirectionLocal.Ascending &&
                searchParameter.sortField === InvoiceKey
              "
              [color]="searchParameter.sortField === InvoiceKey | getSortIconColor"
              [fontSize]="20"
              [right]="true"
            >
              {{ SortKey }}
            </dxo-icon>
          </span>
        </ng-template>

        <ng-template dxoHeaderKey="billGroup">
          <span
            tabindex="0"
            class="sort-header"
            (click)="onClickTableHeader(BillGroupNameKey)"
            (keypress)="onClickTableHeader(BillGroupNameKey)"
            data-e2e="bill-group-title"
          >
            {{ BillGroupText }}
            <dxo-icon
              [class.ascending]="
                searchParameter.sortDirection === SortDirectionLocal.Ascending &&
                searchParameter.sortField === BillGroupNameKey
              "
              [color]="searchParameter.sortField === BillGroupNameKey | getSortIconColor"
              [fontSize]="20"
              [right]="true"
            >
              {{ SortKey }}
            </dxo-icon>
          </span>
        </ng-template>

        <ng-template dxoHeaderKey="AmountUI">
          <span
            tabindex="0"
            class="sort-header"
            (click)="onClickTableHeader(AmountKey)"
            (keypress)="onClickTableHeader(AmountKey)"
            data-e2e="amount-title"
          >
            {{ PaymentAmountText }}
            <dxo-icon
              [class.ascending]="
                searchParameter.sortDirection === SortDirectionLocal.Ascending &&
                searchParameter.sortField === AmountKey
              "
              [color]="searchParameter.sortField === AmountKey | getSortIconColor"
              [fontSize]="20"
              [right]="true"
            >
              {{ SortKey }}
            </dxo-icon>
          </span>
        </ng-template>

        <ng-template dxoKey="invoice" let-item let-index="index">
          <span class="list-cell" [attr.data-e2e]="'invoice-period-' + index">{{ item.InvoicePeriod | billingPeriodToStringPipe }}</span>
        <span>{{ item.InvoiceNumber }}</span>
        </ng-template>

        <ng-template dxoKey="billGroup" let-item let-index="index">
          <span class="list-cell" [attr.data-e2e]="'bill-group-name-' + index">{{ item.BillGroupName }}</span>
          <span>{{ item.BillGroupNumber }}</span>
        </ng-template>

        <ng-template dxoKey="AmountUI" let-item let-index="index">
          <dxo-text-input
            class="amount-field"
            [id]="'paymentAmount' + index"
            [characterSet]="CharSetNumericWithDecimalDollarComma"
            [(value)]="item.AmountUi"
            [error]="item.AmountUiError"
            [errorMessage]="ErrorMessageCurrencyNotFloat"
            maxlength="12"
            [dxoDataset]="[{ selector: 'input', data: { pii: '', e2e:'amount-field-' + index } }]"
            (input)="onAmountChange(item)"
          >
          </dxo-text-input>
        </ng-template>
      </dxo-data-table>

      <div class="row">
        <span class="total-label">Total amount</span>
        <span class="total-amount" data-e2e="total-amount-value">{{ totalAmount | currency }}</span>
      </div>
    </card-body>
  </dxo-card>
</div>

<div id="payment-card">
  <dxo-card bodyHeader="Bank details" data-e2e="bank-details-header">
    <card-body>
      <form [formGroup]="formGroup" (ngSubmit)="submit()">
        <div class="data-containter">
          <div class="data-container">
            <div class="text-input">
              <div class="row-input">
                <dxo-text-input
                  class="input-width-300"
                  input-id="routingNumber"
                  label="{{ RoutingNumberText }}"
                  data-pii
                  formControlName="routingNumber"
                  [errorControl]="formErrors.routingNumber"
                  [dxoDataset]="[{data: {e2e: 'routing-number-input'} }]"
                ></dxo-text-input>
                <dxo-text-input
                  class="input-width-300"
                  input-id="accountNumber"
                  label="{{ AccountNumberText }}"
                  data-pii
                  formControlName="accountNumber"
                  [errorControl]="formErrors.accountNumber"
                  [dxoDataset]="[{data: {e2e: 'account-number-input'} }]"
                ></dxo-text-input>
              </div>
            </div>
            <div class="sel">{{ AccountTypeText }}</div>

            <dxo-radio-select formControlName="accountTypeSelection" [showBorder]="false" [data]="accountTypeOptions">
            </dxo-radio-select>
          </div>
        </div>
      </form>
      <dxo-modal
        [title]="modalData.title"
        [shouldShowCloseX]="ModalShowClose"
        (closeModal)="modalClose(modalData.type)"
        [maxWidth]="ModalWidth"
        *ngIf="modalShow"
      >
        <modal-body *ngIf="!isLoading">
          {{ modalData.body }}
          <p *ngIf="hasSubText">{{ modalData.subText }}</p>
          <dxo-button
            [primary]="ModalPrimary"
            [text]="CloseText"
            (handleClick)="modalClose(modalData.type)"
          ></dxo-button>
        </modal-body>
        <modal-body class="loader-container" *ngIf="isLoading">
          <dxo-circular-loader text="Loading..." [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
        </modal-body>
      </dxo-modal>
      <div>
        <div class="legal-text-container">
          <span class="legal-text">{{ LegalPrefaceText }}</span>
          <a
            class="legal-text-link"
            (click)="modalOpen(LegalType)"
            (keydown)="modalOpen(LegalType)"
            [text]="ModalTitleLegal"
          >
          </a>
        </div>

        <div class="button-container">
          <div class="back-button">
            <dxo-button
              text="Cancel payment"
              data-category="payment"
              data-action="Close Modal"
              (handleClick)="goBillingList()"
              icon="chevron_left"
              [dxoDataset]="[{data: {e2e: 'cancel-payment-button'} }]"
            >
            </dxo-button>
          </div>

          <dxo-button
            [primary]="true"
            [text]="ButtonTextPayNow"
            data-category="payment"
            data-action="Close Modal"
            (handleClick)="payNow()"
            [disabled]="!pageValid()"
            [dxoDataset]="[{data: {e2e: 'pay-now-button'} }]"
          >
          </dxo-button>
        </div>
      </div>
    </card-body>
  </dxo-card>
</div>
